import { getServiceWrapper } from 'core/service-wrapper'
import _ from 'lodash'
import { formatNumber } from 'core/service/lib/number-format'
import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/messages'
import BIMESSAGES from 'core/data-model/constants/bi-messages'
import values from 'core/data-model/constants/values'
import React, { Suspense } from 'react'

const _getProductName = (productName, displayProduct) => {
  const selectedCampaignPlan = displayProduct.selectedCampaignPlan
  let displayProductName
  if (selectedCampaignPlan === values.MEK1) {
    displayProductName = BIMESSAGES.SUKHAPABDEKDEE_PLAN.MEK1
  } else if (selectedCampaignPlan === values.MEK2) {
    displayProductName = BIMESSAGES.SUKHAPABDEKDEE_PLAN.MEK2
  } else if (values.LIFEREADY_CAMPAIGN_CODE.includes(displayProduct.code)) {
    displayProductName = BIMESSAGES.LIFE_READY_PACKAGE_NAME_THAI
  } else if (values.CANCERX5_CAMPAIGN_CODE.includes(displayProduct.code)) {
    displayProductName = BIMESSAGES.LIFE_READY_PACKAGE_NAME_THAI
  } else if (Object.values(values.GLOBAL_INDEX_16_6_CODE).includes(displayProduct.code)) {
    displayProductName = BIMESSAGES.GLOBAL_INDEX_16_6_NAME_THAI
  } else if (Object.values(values.INDEX_LINKED_25_5_CODE).includes(displayProduct.code)) {
    displayProductName = BIMESSAGES.INDEX_LINKED_25_5_NAME_THAI
  } else if (Object.values(values.INDEX_LINKED_15_8_CODE).includes(displayProduct.code)) {
    displayProductName = BIMESSAGES.INDEX_LINKED_15_8_NAME_THAI
  } else {
    displayProductName = productName
  }
  return Mustache.render(BIMESSAGES.BASIC_PLAN_DETAILS, {
    name: displayProductName,
    code: displayProduct.basicPlanCode,
  })
}

const renderGraph = (basicPlanCode) => {
  const serviceWrapper = getServiceWrapper()
  const className = `graph-${basicPlanCode}`
  return (
    <Suspense fallback={null}>
      {(() => {
        switch (basicPlanCode) {
          case 'E20F10':
            return serviceWrapper.renderGraph('E20F10', className)
          case 'E25F15':
            return serviceWrapper.renderGraph('E25F15', className)
          case 'E25F25':
            return serviceWrapper.renderGraph('E25F25', className)
          case 'S14G5T1':
            return serviceWrapper.renderGraph('S14G5T1', className)
          case 'E10G3A':
            return serviceWrapper.renderGraph('E10G3A', className)
          case 'E16G6A':
          case 'E16G6AS':
            return serviceWrapper.renderGraph('E16G6A', className)
          case 'E25G5A':
          case 'E25G5AS':
            return serviceWrapper.renderGraph('E25G5A', className)
          case 'E15G8A':
          case 'E15G8AS':
            return serviceWrapper.renderGraph('E15G8A', className)
          case 'MRTA_FULL':
            return serviceWrapper.renderGraph('MRTA_FULL', className)
          case 'MRTA_PLUS':
            return serviceWrapper.renderGraph('MRTA_PLUS', className)
          case 'MRTA_TRUNCATE':
            return serviceWrapper.renderGraph('MRTA_TRUNCATE', className)
          case 'W80F06':
            return serviceWrapper.renderGraph('W80F06', className)
          default:
            return null
        }
      })()}
    </Suspense>
  )
}

const renderCoveragePeriod = (displayProduct, calculatedCoveragePeriod) => {
  if (displayProduct?.basicPlanCode === 'W80F06') {
    return BIMESSAGES.COVERAGE_PERIOD_ISMART_SUFFIX
  }
  return `${calculatedCoveragePeriod} ${MESSAGES.TIME_UNIT_YEAR}`
}

const ProductBenefitsSummary = ({
  displayProduct,
  sumAssured,
  basicPremium,
  calculatedPaymentPeriod,
  calculatedCoveragePeriod,
  benefitSummaryHeader,
  selectedModelFactorID,
  selectedModelFactorLabel,
  showGraph = true,
}) => {
  const productName = _.isFunction(benefitSummaryHeader)
    ? // $$FlowFixMe
      benefitSummaryHeader({
        displayProduct,
        sumAssured,
        basicPremium,
        calculatedPaymentPeriod,
        calculatedCoveragePeriod,
      })
    : benefitSummaryHeader
  return (
    <div id="product-benefits-summary" className="product">
      <h3 className="name">{_getProductName(productName, displayProduct)}</h3>
      <div className="info-list">
        <div id="benefits-coverage-period" className="info">
          <p className="label">{BIMESSAGES.COVERAGE_PERIOD}</p>
          <p className="value">{renderCoveragePeriod(displayProduct, calculatedCoveragePeriod)}</p>
        </div>
        <div id="benefits-payment-period" className="info">
          <p className="label">{BIMESSAGES.PAYMENT_PERIOD}</p>
          <p className="value">
            {selectedModelFactorID === 'model-factor_5' ? selectedModelFactorLabel : calculatedPaymentPeriod + ' ปี'}
          </p>
        </div>
        <div id="benefits-sum-assured" className="info">
          <p className="label">{BIMESSAGES.BASIC_PLAN_SUM_ASSURED}</p>
          <p className="value">{formatNumber(sumAssured)} บาท</p>
        </div>
        <div id="benefits-basic-premium" className="info">
          <p className="label">{BIMESSAGES.BASIC_PREMIUM}</p>
          <p className="value">{formatNumber(basicPremium, 2)} บาท</p>
        </div>
      </div>
      {showGraph && displayProduct ? renderGraph(displayProduct.basicPlanCode) : ''}
    </div>
  )
}

export default ProductBenefitsSummary
